import { Search } from '@mui/icons-material';
import { Box, Button, InputAdornment, TextField, Typography } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router-dom';

const Apps = () => {
    const navigate = useNavigate();
  return (
    <Box sx={{mt:3}}>
          <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
      <Typography variant="h3" fontWeight="Medimum">
        Apps
      </Typography>
      <Box sx={{ display: "flex", gap: 2, width: "40%" }}>
    <Button
      sx={{
        borderRadius: "8px",
        bgcolor: "#2FB354",
        color: "white",
        py: 1.5,
        width: "150px", 
        "&:hover": {
          bgcolor: "#249D47",
        },
      }}
      onClick={() => {
        navigate("/createApp");
      }}
    >
      {/* <Add sx={{ mr: 1 }} /> */}
      Create App
    </Button>
    <TextField
      variant="outlined"
      placeholder="Search Apps"
      fullWidth
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        },
      }}
    />
  </Box>
     
</Box>
    </Box>
  )
}

export default Apps;